export const ROOT = 'fixed z-dialog bg-white mb-0';
